import React from 'react';

import { CheckCircleFilled } from '@ant-design/icons';

import Spin from 'components/Spin';
import type { ICardApiResponse } from 'v2/interfaces/customer';

import type { ICard } from '../index';
import PreviewCard from '../previewCard';

interface IProps {
  cardsList: ICardApiResponse[];
  isLoadingCards?: boolean;
  selectedCard?: ICard;
  onCardClick?: (card: ICard) => void;
}

const ListCards = ({ cardsList, isLoadingCards, selectedCard, onCardClick }: IProps) => {
  if (isLoadingCards) {
    return (
      <div className='text-content-subtitle flex flex-col items-center gap-2 py-4'>
        <Spin />
        <p>Carregando formas de pagamento cadastradas</p>
      </div>
    );
  }

  if (!cardsList?.length)
    return <p className='text-content-subtitle text-sm'>Nenhuma forma de pagamento cadastrada encontrada.</p>;

  return (
    <div className='flex flex-wrap items-center justify-center gap-4'>
      {cardsList.map(card => {
        const currentCard: ICard = {
          id: card.id,
          name: card.holder,
          number: card.number,
          cvc: '',
          expiry: '',
          issuer: card.flag
        };
        const isSelected = selectedCard?.id === currentCard.id;

        return (
          <div
            key={card.id}
            className='relative w-full max-w-72.5 origin-center scale-90 cursor-pointer transition-transform duration-200 hover:scale-95 aria-selected:scale-100'
            aria-selected={isSelected}
            onClick={() => onCardClick?.(currentCard)}
          >
            {isSelected && (
              <CheckCircleFilled className='text-primary bg-surface-default absolute -top-2 -right-2 z-1 rounded-full text-4xl' />
            )}
            <PreviewCard card={currentCard} />
          </div>
        );
      })}
    </div>
  );
};

export default ListCards;
